import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";

import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy
} from "firebase/firestore";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function EditionSlider() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [editions, setEditions] = useState([]);

  const openAlert = () => setAlertOpen(true);
  const closeAlert = () => setAlertOpen(false);

  const WHATSAPP_LINK =
    "https://wa.me/9747518960?text=Hello!%20I%20want%20to%20purchase%20The%20Guide%20Edition.";

  // 🔥 Fetch editions in reverse order ONLY (5 → 4 → 3 → 2 → 1)
  useEffect(() => {
    const fetchEditions = async () => {
      try {
        const q = query(
          collection(db, "editions"),
          orderBy("createdAt", "desc") // ✅ reverse order
        );

        const snap = await getDocs(q);
        const list = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setEditions(list);
      } catch (err) {
        console.error("Firestore Error:", err);
      }
    };

    fetchEditions();
   }, []);

 
  return (
    <>
      <div className="w-full max-w-7xl mx-auto px-4 py-10 overflow-hidden">
        <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">
          The Guide Editions
        </h1>

        <Swiper
          modules={[Navigation, Pagination, A11y]}
          navigation
                   loop={false}          // ❌ NO mirror
          watchOverflow={true}  // ❌ NO auto loop
          spaceBetween={25}
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="rounded-2xl p-6"
        >
          {editions.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className="flex flex-col h-[560px] rounded-xl shadow-md bg-white">
                
                {/* Clickable Image */}
                <div
                  className="w-full h-[420px] cursor-pointer"
                  onClick={openAlert}
                >
                  <img
                    src={slide.coverpage}
                    alt={slide.name}
                    onError={(e) => {
                      e.target.src = "/fallback.jpg";
                    }}
                    className="w-full h-full object-cover rounded-t-xl"
                  />
                </div>

                <div className="p-4 flex flex-col items-center justify-center flex-1">
                  <h2 className="text-xl font-bold text-gray-800 text-center">
                    {slide.name}
                  </h2>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Alert Modal */}
      {alertOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4">
          <div className="bg-white rounded-xl shadow-2xl p-6 max-w-sm w-full mx-auto text-center border-t-4 border-green-600">
            
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Premium Edition Access
            </h3>

          <p className="text-gray-700 pb-2 text-base font-medium text-left">
  This edition is <b>not available in PDF format</b>. We do not provide or share
  digital copies of <b>The Guide Magazine</b>.  
  If you would like to purchase an <b>original hard copy</b>, please contact us
  directly via WhatsApp and place your order now.
</p>

            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white py-3 px-6 rounded-full font-bold hover:bg-green-700 transition shadow-md w-full block"
            >
              Chat on WhatsApp
            </a>

            <button
              onClick={closeAlert}
              className="mt-4 text-gray-500 hover:text-gray-700 text-sm"
            >
              I understand, close this.
            </button>
          </div>
        </div>
      )}
    </>
  );
}
